import React from "react";
import DescribeImage from "components/Question/Mocks/Speaking/DescribeImage.jsx";
import RetellLec from "components/Question/Mocks/Speaking/RetellLec";
import ShortQue from "components/Question/Mocks/Speaking/ShortQue";

import Essay from "components/Question/Mocks/Writting/Essay";
import Summary from "components/Question/Mocks/Writting/Summary";

import MultipleAnswer from "components/Question/Mocks/Reading/MultipleAnswer";
import ReadingBlank from "components/Question/Mocks/Reading/ReadingBlank";
import Reorder from "components/Question/Mocks/Reading/Reorder1";
import SingleAnswer from "components/Question/Mocks/Reading/SingleAnswer";
import WrittingBlank from "components/Question/Mocks/Reading/WrittingBlank";

import CorrectSummary from "components/Question/Mocks/Listening/CorrectSummary";
import Dictation from "components/Question/Mocks/Listening/Dictation";
import Highlight from "components/Question/Mocks/Listening/Highlight";
import ListeningBlank from "components/Question/Mocks/Listening/ListeningBlank";
import McqMulti from "components/Question/Mocks/Listening/McqMulti";
import McqSingle from "components/Question/Mocks/Listening/McqSingle";
import MissingWord from "components/Question/Mocks/Listening/MissingWord";
import Summer from "components/Question/Mocks/Listening/Summer";

import Skeleton from "react-loading-skeleton";
import { Card, Row } from "react-bootstrap";
import ReadAloud from "components/Question/Mocks/Speaking/ReadAloud";
import RepeatSentence from "components/Question/Mocks/Speaking/RepeatSentece";
import RespondToSituation from "components/Question/Mocks/Speaking/RespondToSituation";
import SummarizeGroupDiscussion from "components/Question/Mocks/Speaking/SummarizeGroupDiscussion";
import "../custom.css";

const Section = ({ mockData, data, loading }) => {
  let que;
  let title = "";
  let quesTitle = "";

  if (mockData.questionData.length > 0) {
    // console.log("questionData");
    quesTitle = mockData.questionData[mockData.currentQuestion].q_title;
  }

  switch (mockData.type) {
    case 1:
      que = <ReadAloud {...data} />;
      title =
        "Look at the text below. In 35 seconds, you must read this text aloud as naturally and clearly as possible. You have 35 seconds to read aloud.";
      break;
    case 2:
      que = <RepeatSentence {...data} />;
      title =
        "You will hear a sentence. Please repeat the sentence exactly as you hear it. You will hear the sentence only once.";
      break;
    case 3:
      que = <DescribeImage {...data} />;
      title =
        "Look at the image below. In 25 seconds, please speak into the microphone and describe in detail what the image is showing. You will have 40 seconds to give your response.";
      break;
    case 4:
      que = <RetellLec {...data} />;
      title =
        "Listen to and read a description of a situation. You will have 20 seconds to think about your answer. Then you will hear a beep. You will have 40 seconds to answer the question. Please answer as completely as you can.";
      break;
    case 5:
      que = <ShortQue {...data} />;
      title =
        "You will hear a question. Please give a simple and short answer. Often just one or a few words is enough.";
      break;
    case 6:
      que = <Summary {...data} />;
      title =
        "Read the passage below. Summarise the passage using between 25 and 50 words. Type your response in the box at the bottom of the screen. You have 10 minutes to finish this task. Your response will be judged on the quality of your writing and on how well your response presents the key points in the passage.";
      break;
    case 7:
      que = <Essay {...data} />;
      title =
        "Read a description of a situation. Then write an email about the situation. You will have 9 minutes. You should aim to write 80-120 words. Write using complete sentences.";
      break;
    case 8:
      que = <SingleAnswer {...data} />;
      title =
        "Read the text and answer the multiple-choice question by selecting the correct response. Only one response is correct.";
      break;
    case 9:
      que = <MultipleAnswer {...data} />;
      title =
        "Read the text and answer the question by selecting all the correct responses. More than one response is correct.";
      break;
    case 10:
      que = <Reorder {...data} />;
      title =
        "The text boxes in the left panel have been placed in a random order. Restore the original order by dragging the text boxes from the left panel to the right panel.";
      break;
    case 11:
      que = <ReadingBlank {...data} />;
      title =
        "In the text below some words are missing. Drag words from the text box below to the appropriate place in the text. To undo an answer choice, drag the word back to the box below the text.";
      break;
    case 12:
      que = <WrittingBlank {...data} />;
      title =
        "Below is a text with blanks. Click on each blank, a list of choices will appear. Select the appropriate answer choice for each blank.";
      break;
    case 13:
      que = <Summer {...data} />;
      title =
        "You will hear a short audio. Write a summary for a fellow student who was not present. You should write 20-30 words. You have 8 minutes to finish this task. Your response will be judged on the quality of your writing and on how well your response presents the key points presented in the audio.";
      break;
    case 14:
      que = <McqSingle {...data} />;
      title =
        "Listen to the recording and answer the multiple-choice question by selecting the correct response. Only one response is correct.";
      break;
    case 15:
      que = <McqMulti {...data} />;
      title =
        "Listen to the recording and answer the question by selecting all the correct responses. You will need to select more than one response.";
      break;
    case 16:
      que = <ListeningBlank {...data} />;
      title =
        "You will hear a recording. Type the missing words in each blank.";
      break;
    case 17:
      que = <CorrectSummary {...data} />;
      title =
        "You will hear a recording. Click on the paragraph that best relates to the recording.";
      break;
    case 18:
      que = <MissingWord {...data} />;
      title =
        "You will hear a recording about " +
        quesTitle +
        ". At the end of the recording the last word or group of words has been replaced by a beep. Select the correct option to complete the recording.";
      break;
    case 19:
      que = <Highlight {...data} />;
      title =
        "You will hear a recording. Below is a transcription of the recording. Some words in the transcription differ from what the speaker(s) said. Please click on the words that are different.";
      break;
    case 20:
      que = <Dictation {...data} />;
      title =
        "You will hear a sentence. Type the sentence in the box below exactly as you hear it. Write as much of the sentence as you can. You will hear the sentence only once.";
      break;
    // case 22:
    //   que = <SummarizeGroupDiscussion {...data} />;
    //   title =
    //     "You will hear three people having a discussion. When you hear the beep, summarize the whole discussion. You will have 10 seconds to prepare and 2 minutes to give your response.";
    //   break;
    // case 21:
    //   que = <RespondToSituation {...data} />;
    //   title =
    //     "Listen to and read a description of a situation. You will have 10 seconds to think about your answer. Then you will hear a beep. You will have 40 seconds to answer the question. Please answer as completely as you can.";
    //   break;
    default:
    // code block
  }

  return (
    <>
      <Card.Body className="mock-container">
        <p className="question-title-ext">{title}</p>
        <hr />
        <Row className="unselectable">
          {mockData?.secondCount === 0 && (
            <div>Time up please restart the Test</div>
          )}
          {mockData?.internet ? (
            mockData?.secondCount !== 0 &&
            mockData?.questionData &&
            !loading &&
            que
          ) : (
            <>
              <Skeleton count={1} width={"50%"} height={200} containerClassName="skeleton-wrapper__mockrecording"
              />
              <Skeleton count={5} width={"100%"} containerClassName="skeleton-wrapper__mocklines"
              />
            </>
          )}
        </Row>
      </Card.Body>
    </>
  );
};

export default Section;
